import { getPageTitle } from "components/utils/seo";

import config from "./config";

let analytics = null;
let analyticsInstance = null;

const getAnalytics = async () => {
  if (!analyticsInstance) {
    const { default: Analytics } = await import("analytics");
    const { bdayMetricsPlugin, trackCardMetric } = await import("./plugins/bday-metrics-plugin");
    const { googleAnalyticsPlugin } = await import("./plugins/googe-analytics-plugin");
    const { metaPixelPlugin } = await import("./plugins/meta-pixel-plugin");

    analyticsInstance = Analytics({
      app: "bday-web",
      version: 1,
      plugins: [bdayMetricsPlugin(config), googleAnalyticsPlugin(config), metaPixelPlugin(config)],
    });

    const page = ({ url, path, isRoot, ...rest }) => {
      // Ignore locations that send page view metrics themselves
      if (path.indexOf("/card/send/") > 0 && isRoot) {
        return;
      }
      analyticsInstance.page({
        url: url || config.baseUrl,
        path: path,
        title: getPageTitle(path),
        ...rest,
      });
    };

    const track = (event, payload, action = event, category = "Event") => {
      analyticsInstance.track(event, { ...payload, action, category });
    };

    const identify = (member) => {
      if (!member?.memberId) {
        analyticsInstance.reset();
        return;
      }
      analyticsInstance.identify(member.memberId, {
        userId: member.memberId,
        //firstName: member.firstName,
        //lastName: member.lastName,
        //email: member.email,
      });
    };
    analytics = {
      page,
      track,
      trackCardMetric,
      identify,
    };
  }
  return analytics;
};

const bdaylytics = new Proxy(
  {},
  {
    get:
      (_, method) =>
      async (...args) => {
        const analytics = await getAnalytics();
        if (analytics[method]) {
          return analytics[method](...args);
        }
      },
  }
);

export default bdaylytics;
